import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
  margin-bottom: 20px;
  align-items: center;
  justify-content: flex-start;

  .filter-item {
    display: flex;
    align-items: center;
    gap: 2px;

    &.first-item {
      margin-left: auto;
    }

    .filter-icon {
      width: 15px;
      height: 15px;
    }
  }

  .filter-button {
    padding: 4px 12px;
    border-radius: 50px;
    background-color: ${colors.lightGray};
    color: ${colors.darkBlue};
    font-size: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;

    &:hover {
      background-color: ${colors.lightBlueGrayBackground};
    }

    &.active {
      background-color: ${colors.blue};
      color: ${colors.white};
    }
  }
`;
